import { useTranslation } from 'react-i18next';
import { Swords } from 'lucide-react';

import { useMainButton } from '@/hooks/useMainButton';

interface LinkCrStepProps {
  onLinkNow: () => void;
  onLater: () => void;
}

/** CR link invite. "Link now" exits the wizard into the proven /duels/link. */
export function LinkCrStep({ onLinkNow, onLater }: LinkCrStepProps) {
  const { t } = useTranslation('onboarding');

  useMainButton({ text: t('linkCr.cta'), onClick: onLinkNow });

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 px-6 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-brand/10 text-brand">
        <Swords aria-hidden className="h-8 w-8" />
      </span>
      <h1 className="text-2xl font-bold text-fg">{t('linkCr.title')}</h1>
      <p className="text-sm text-fg-muted">{t('linkCr.body')}</p>
      <button
        type="button"
        onClick={onLater}
        className="text-xs font-semibold text-fg-muted underline"
      >
        {t('linkCr.skip')}
      </button>
    </div>
  );
}
